import React, { useState, useEffect, useRef } from 'react';
import { Navbar, Nav, Container, NavDropdown, Form, Button } from 'react-bootstrap';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import '../assets/css/Style.css';
import { logo_wh, logo_blk } from './ImageList';
import baseURL from './baseURL';
import { useTranslation } from 'react-i18next';
import englishFlag from '../assets/images/united-states.svg';
import frenchFlag from '../assets/images/france.svg';
import dutchFlag from '../assets/images/netherlands.svg';
import portugalFlag from '../assets/images/portugal.svg';

export default function Header() {
    const navigate = useNavigate();
    const location = useLocation();
    const { t, i18n } = useTranslation();
    const [expand, setExpand] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);
    const [isLangOpen, setIsLangOpen] = useState(false);
    const [currentLang, setCurrentLang] = useState(localStorage.getItem('language') || navigator.language.split('-')[0] || 'en');
    const languageDropdownRef = useRef(null);
    const [show, setShow] = useState(false);
    const [partnerList, setPartnerList] = useState([]);
    const languages = [
        { code: 'en', name: 'English', flag: englishFlag },
        { code: 'fr', name: 'Français', flag: frenchFlag },
        { code: 'nl', name: 'Nederlands', flag: dutchFlag },
        { code: 'pt', name: 'Português', flag: portugalFlag }
    ];

    const handleExpand = (value) => {
        setExpand(value);
    };

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 50) {
                setIsScrolled(true);
            } else {
                setIsScrolled(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    useEffect(() => {
        const savedLang = localStorage.getItem('language');
        if (savedLang) {
            setCurrentLang(savedLang);
            i18n.changeLanguage(savedLang);
        } else {
            const browserLang = navigator.language.split('-')[0];
            const supportedLang = languages.find(lang => lang.code === browserLang);
            if (supportedLang) {
                setCurrentLang(browserLang);
                i18n.changeLanguage(browserLang);
                localStorage.setItem('language', browserLang);
            } else {
                setCurrentLang('en');
                i18n.changeLanguage('en');
                localStorage.setItem('language', 'en');
            }
        }
    }, [i18n]);

    const handleLanguageChange = (langCode, event) => {
        event.preventDefault();
        event.stopPropagation();
        setCurrentLang(langCode);
        i18n.changeLanguage(langCode);
        localStorage.setItem('language', langCode);
        setIsLangOpen(false);
    };

    const handleLanguageButtonClick = (event) => {
        event.preventDefault();
        event.stopPropagation();
        event.nativeEvent.stopImmediatePropagation();
        setIsLangOpen(prev => !prev);
    };

    useEffect(() => {
        // fetchPartnerList();
    }, []);






    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handlePartnerClick = (category) => {
        // Only close mobile menu if it's open
        if (show) {
            handleClose();
        }
        navigate('/catagory', { state: { category } });
    };

    const currentLanguage = languages.find(lang => lang.code === currentLang);

    return (
        <div>
            <header className={`fixed-top ${isScrolled ? 'scrolled' : ''}`}>
                <Navbar collapseOnSelect expand="lg" className="p-4">
                    <Container>
                        <Navbar.Brand as={Link} to="/" className="d-flex align-items-center">
                            <span className="logo_sec">
                                <img src={logo_wh} alt="logo" className="logo-wh" />
                                <img src={logo_blk} alt="logo" className="logo-blk" />
                            </span>
                        </Navbar.Brand>
                        <Navbar.Toggle class="text-white" aria-controls={`offcanvasNavbar-expand-${expand}`} />
                        {/* <button className="d-lg-none mobile-toggle-btn bg-transparent" onClick={handleShow}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-list text-white" viewBox="0 0 16 16">
                                <path fillRule="evenodd" d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z" />
                            </svg>
                        </button> */}
                        <Navbar.Offcanvas
                            id={`offcanvasNavbar-expand-${expand}`}
                            aria-labelledby={`offcanvasNavbarLabel-expand-${expand}`}
                            placement="end"
                        >
                            <Offcanvas.Header closeButton closeVariant="white">
                            </Offcanvas.Header>
                            <Offcanvas.Body>
                                <Nav className="justify-content-end flex-grow-1 pe-3">
                                    <Nav.Link as={Link} to="/" className="mx-2 text-white">{t('home')}</Nav.Link>
                                    <Nav.Link as={Link} to="/" className="mx-2 text-white">{t('aboutHeader')}</Nav.Link>
                                    <NavDropdown
                                        title={t('partners')}
                                        id={`offcanvasNavbarDropdown-expand-${expand}`}
                                        className="mx-2"
                                    >

                                        <NavDropdown.Item onClick={() => handlePartnerClick("Architect")}>{t('architects')}</NavDropdown.Item>
                                        <NavDropdown.Item onClick={() => handlePartnerClick("Builder")}>{t('builders')}</NavDropdown.Item>
                                        <NavDropdown.Item onClick={() => handlePartnerClick("Supplier")}>{t('marketplace')}</NavDropdown.Item>

                                    </NavDropdown>
                                    <Nav.Link as={Link} to="/" className="mx-2 text-white">{t('contact')}</Nav.Link>
                                    <div className="language-selector position-relative lg:mx-2 mx-0" ref={languageDropdownRef}>
                                        <button
                                            className="language-button text-white bg-transparent border-0 d-flex align-items-center"
                                            onClick={handleLanguageButtonClick}
                                            type="button"
                                            aria-expanded={isLangOpen}
                                            aria-haspopup="true"
                                        >
                                            {currentLanguage?.flag ? (
                                                <img
                                                    src={currentLanguage.flag}
                                                    alt={currentLanguage.name}
                                                    style={{
                                                        width: '25px',
                                                        height: '25px',
                                                        borderRadius: '50%',
                                                        objectFit: 'cover',
                                                        marginRight: '8px'
                                                    }}
                                                    onError={(e) => {
                                                        console.log('Flag image failed to load:', currentLanguage.flag);
                                                        e.target.style.display = 'none';
                                                    }}
                                                    onLoad={() => {
                                                        console.log('Flag image loaded successfully:', currentLanguage.flag);
                                                    }}
                                                />
                                            ) : (
                                                <div>
                                                    <img src={englishFlag} alt="English" />
                                                </div>
                                            )}
                                            {currentLanguage?.name}
                                        </button>

                                        {isLangOpen && (
                                            <div className="language-dropdown" role="menu" aria-labelledby="language-button">
                                                {languages.map((lang) => (
                                                    <div
                                                        key={lang.code}
                                                        className="language-option d-flex align-items-center p-2"
                                                        onClick={(e) => handleLanguageChange(lang.code, e)}
                                                        role="menuitem"
                                                        tabIndex={0}
                                                        onKeyDown={(e) => {
                                                            if (e.key === 'Enter' || e.key === ' ') {
                                                                e.preventDefault();
                                                                handleLanguageChange(lang.code, e);
                                                            }
                                                        }}
                                                    >
                                                        {lang.flag ? (
                                                            <img
                                                                src={lang.flag}
                                                                alt={lang.name}
                                                                style={{
                                                                    width: '25px',
                                                                    height: '25px',
                                                                    borderRadius: '50%',
                                                                    objectFit: 'cover',
                                                                    marginRight: '8px'
                                                                }}
                                                                onError={(e) => {
                                                                    console.log('Dropdown flag image failed to load:', lang.flag);
                                                                    e.target.style.display = 'none';
                                                                }}
                                                                onLoad={() => {
                                                                    console.log('Dropdown flag image loaded successfully:', lang.flag);
                                                                }}
                                                            />
                                                        ) : (
                                                            <div>
                                                                <img src={englishFlag} alt="English" />
                                                            </div>
                                                        )}
                                                        {lang.name}
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                </Nav>

                            </Offcanvas.Body>
                        </Navbar.Offcanvas>
                    </Container>
                </Navbar>
            </header>
        </div>
    );
}
